import { useState } from "react"
import { Link, Navigate, useNavigate } from "react-router-dom"
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"
import { Label } from "@/components/ui/label"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import Spinner from "~/components/Spinner"
import { useAuth } from "~/AuthContext"
import routes from "~/routes"

const passwordResetEnabled = document.querySelector('meta[name="password-reset-enabled"]')?.content === "true"

export default function SignIn() {
  const { user, signIn } = useAuth()
  const navigate = useNavigate()
  const [ emailAddress, setEmailAddress ] = useState("")
  const [ password, setPassword ] = useState("")
  const [ error, setError ] = useState(null)
  const [ busy, setBusy ] = useState(false)

  if (user) return <Navigate to={routes.home} replace />

  async function handleSubmit(event) {
    event.preventDefault()
    setError(null)
    setBusy(true)

    try {
      await signIn(emailAddress, password)
      navigate(routes.home)
    } catch (err) {
      setError(err.message)
      setBusy(false)
    }
  }

  return (
    <div className="mx-auto mt-24 max-w-sm px-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Jacky Winter Places</CardTitle>
          <p className="text-sm text-muted-foreground">Gardens &amp; Waters bookings</p>
        </CardHeader>
        <CardContent>
          {error && <p className="mb-4 text-sm text-destructive">{error}</p>}

          <form onSubmit={handleSubmit} className="space-y-3">
            <div className="space-y-1.5">
              <Label htmlFor="email_address">Email address</Label>
              <Input
                id="email_address"
                type="email"
                required
                autoFocus
                autoComplete="username"
                placeholder="Enter your email address"
                value={emailAddress}
                onChange={(event) => setEmailAddress(event.target.value)}
                disabled={busy}
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                required
                autoComplete="current-password"
                maxLength={72}
                placeholder="Enter your password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                disabled={busy}
              />
            </div>
            <Button type="submit" className="w-full" disabled={busy}>
              {busy && <Spinner className="size-4" />}
              {busy ? "Signing in…" : "Sign in"}
            </Button>
          </form>

          {passwordResetEnabled && (
            <Link to={routes.forgotPassword} className="mt-4 inline-block text-sm text-muted-foreground">
              Forgot password?
            </Link>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
